import { RecipientStepView } from '@today/ui-domain'
import type { ReactElement } from 'react'
import type { DraftRecipient } from '@/hooks/offers/useOfferWizardDraft'
import { useRecipientStep } from '@/hooks/offers/useRecipientStep'

export interface RecipientStepContainerProps {
	/** The wizard draft's current recipient (from `useOfferWizardDraft`). */
	recipient: DraftRecipient | null
	/** Sets the wizard draft's recipient. */
	onRecipientChange: (recipient: DraftRecipient | null) => void
}

/**
 * Offer wizard Step 1 (TO-122), wired to its hook. The wizard shell (TO-466) mounts
 * this with the draft from `useOfferWizardDraft`; no route exposes it on its own.
 */
export function RecipientStepContainer({ recipient, onRecipientChange }: RecipientStepContainerProps): ReactElement {
	return <RecipientStepView {...useRecipientStep(recipient, onRecipientChange)} />
}
